import axios from 'axios';
import { getToken } from 'helpers';
import { API } from '../constants';
import { paramsSerializer } from '../utils';

export const axiosInstance = axios.create({
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Csrf-Token': getToken()
  }
});

export class FetchError extends Error {
  status?: number;

  constructor(status?: number) {
    super('Failed to fetch data');
    this.name = 'FetchError';
    this.status = status;
  }
}

export const fetcher = async (url: string) => {
  try {
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    throw new FetchError(axios.isAxiosError(error) ? error.response?.status : undefined);
  }
};

export const logout = async () => {
  // Don't wrap errors here: callers rely on response.status to tell an
  // already-expired session (401/403) apart from a real logout failure.
  const response = await axiosInstance.delete(API.LOGOUT);
  return response.data;
};

export const fetchCatalogData = async (params: Record<string, unknown>) => {
  try {
    const response = await axiosInstance.get(API.CATALOG, {
      params: { ...params, is_key: true },
      paramsSerializer
    });
    return response.data;
  } catch {
    throw new Error('Failed to fetch catalog data');
  }
};
